export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8132.210388e1.jpg";